var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"body",staticClass:"body"},[_c('app-breadcrumb',{attrs:{"navInfo":_vm.navInfo}}),_vm._v(" "),_c('router-view',{on:{"breadcrumb":_vm.handleBreadcrumb,"activeIndex":_vm.handleActiveIndex}}),_vm._v(" "),_c('el-backtop',{attrs:{"target":".el-main"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4442d03c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageframe/components/Content.vue
// module id = null
// module chunks = 